import img1 from "../../images/car-dealer.JPG";
import img2 from "../../images/number-guesser.JPG";
import img3 from "../../images/grocery-javascript.JPG";
import img4 from "../../images/password-generator.JPG";
import img5 from "../../images/wikipedia.JPG";
import img6 from "../../images/course-javascript.JPG";

export default [
  {
    id: 1,
    name: "Car-Dealership-Project",
    description:
      "This is a car-dealer project and made up of using  pure Javascript, Bootstrap4,HTML5 and CSS3.",
    code_link: "https://github.com/nagireddy1234/car-dealership-project",
    deploy_link: "https://cardealer-javascript.netlify.app/",
    tools: ["JavaScript", "HTML5", "CSS3", "Bootstrap"],
    icons: ["JavaScript", "HTML5"],
    image: img1,
    image_describe: "car-dealership",
  },
  {
    id: 2,
    name: "Number Guesser",
    description:
      "This is Number Guesser page and made up of using Javascript,HTML5 and CSS3.",
    code_link: "https://github.com/nagireddy1234/Number-guesser",
    deploy_link: "https://nagireddy1234.github.io/Number-guesser/",
    tools: ["JavaScript", "HTML5", "CSS3"],
    icons: ["JavaScript", "HTML5"],
    image: img2,
    image_describe: "number-guesser",
  },
  {
    id: 3,
    name: "GroceryItem-List",
    description:
      "This is GroceryItem-List and made up of using Javascript, Bootstrap4,HTML5 and CSS3.",
    code_link: "https://github.com/nagireddy1234/groceryList-javascript",
    deploy_link: "https://nagireddy1234.github.io/groceryList-javascript/",
    tools: ["JavaScript", "HTML5", "CSS3"],
    icons: ["JavaScript", "HTML5"],
    image: img3,
    image_describe: "Groceryitem-list",
  },
  {
    id: 4,
    name: "Password Generator",
    description:
      "This is Password Generator simple app. It is made up of using Javascript, Bootstrap,HTML5 and CSS3",
    code_link: "https://github.com/nagireddy1234/password-generator",
    deploy_link: "https://nagireddy1234.github.io/password-generator/",
    tools: ["Bootstrap", "Javascript", "HTML5", "CSS3"],
    icons: ["Javascript", "HTML5"],
    image: img4,
    image_describe: "password-generator",
  },
  {
    id: 5,
    name: "wikipedia-search-project",
    description:
      "This is a wikipedia app where we can search for the the things.we know that wikipedia as open content online encyclopedia created through the collaborative effort of a community of users known as Wikipedians.we used http and ajax. It is made up of using Javascript, Bootstrap,HTML5 and CSS3",
    code_link: "https://github.com/nagireddy1234/wikipedia-search-project",
    deploy_link: "https://course-form.netlify.app/",
    tools: ["Bootstrap", "Javascript", "HTML5", "CSS3"],
    icons: ["Javascript", "HTML5"],
    image: img5,
    image_describe: "Wikipedia search project",
  },
  {
    id: 6,
    name: "Course form Project",
    description:
      "This is a basic app where we can do form validation. It is made up of using Javascript, Bootstrap,HTML5 and CSS3",
    code_link: "https://github.com/nagireddy1234/Course-form-Project",
    deploy_link: "https://course-form.netlify.app/",
    tools: ["Bootstrap", "Javascript", "HTML5", "CSS3"],
    icons: ["Javascript", "HTML5"],
    image: img6,
    image_describe: "Course form Project",
  },
];
